<template>
  <div>
    <result-page :trial="true"></result-page>
  </div>

</template>

<script>
import ResultPage from "./ResultPage";
export default {
	name: "TrialResult",
	components: {
	  ResultPage
	},
	data: () => ({
	}),
	computed: {
	},
	methods: {
	},
	created() {
    let slug = this.$route.params.uuid
    this.$store.dispatch('diagnostic/loadTrialRespondent', {slug: slug})
	}
}
</script>